<template>
  <div class="meeting" :style="{ minHeight: height + 'px' }">
    <div class="fixed">
      <div class="header">
        <div class="left">
          <DatePicker :value.sync="date" :month="true" :noMin="true"> </DatePicker>
        </div>
        <div class="right">
          <span>{{ $t('meeting.user.header.invite') }}</span>
          <span>{{ $t('meeting.user.header.book') }}</span>
          <TypeSelect :value.sync="type"></TypeSelect>
        </div>
      </div>

      <div class="top" ref="topScroll">
        <div class="con">
          <div class="date" v-for="(item, index) in list" v-bind:key="item.conferenceDate" @click="select = index + 1">
            <div :class="`area ${select === index + 1 && 'active'}`">
              <span> {{ $t('common.day' + dateFromat(item.conferenceDate)[0]).slice(2) }}</span>
              <span>
                {{
                  dateFromat(item.conferenceDate)[1]
                    .toString()
                    .padStart(2, '0')
                }}</span
              >
            </div>
            <div class="foot">
              <span class="invite" v-if="hasMeeting(item.list)[0]"></span>
              <span class="book" v-if="hasMeeting(item.list)[1]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Skeleton title :row="8" :loading="loading">
      <div class="main">
        <div class="list" v-for="(item, index) in listFilter" v-bind:key="item.id">
          <div class="listCon">
            <div class="left">
              <span class="begin">{{ item.beginTime | hourFilter }}</span>
              <span class="end">{{ item.endTime | hourFilter }}</span>
            </div>

            <div class="rightCon" @click="goToMeeting(item.conferenceId)">
              <div class="right">
                <div class="top2">
                  <span class="title">
                    <span :class="`${isCreator(item.creatorId) ? 'book' : 'invite'}`"></span>
                    <span>{{ item.conferenceName }}</span>
                  </span>
                  <span :class="`status num${item.status}`">{{ $t('meeting.list.status.num' + item.status) }}</span>
                </div>
                <div class="tips">
                  <Iconfont name="iconfaqiren" class="personIcon"></Iconfont>
                  <span>{{ item.promoter && item.promoter.personName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div :class="`addon ${hasAfter(index)}`">
            <div class="option">
              <div class="optionCon" v-if="editOrDelete(item)[0]">
                <div class="bigDelete" @click="deleteMeeting(item.conferenceId, item.conferenceName)">
                  <Iconfont name="iconshanchuhuiyi"></Iconfont>
                  <span>{{ $t('common.cancel') }}</span>
                </div>
              </div>
              <div class="optionCon" v-if="editOrDelete(item)[1]">
                <div class="edit" @click="editMeeting(item)">
                  <Iconfont name="iconxiugaihuiyi"></Iconfont>
                  <span>{{ $t('common.edit') }}</span>
                </div>
                <div class="delete" @click="deleteMeeting(item.conferenceId, item.conferenceName)">
                  <Iconfont name="iconshanchuhuiyi"></Iconfont>
                  <span>{{ $t('common.cancel') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Skeleton>
  </div>
</template>

<script>
import moment from 'moment';
import { Skeleton, Dialog } from 'vant';
import DatePicker from '@/components/meetingDateSelect';
import Iconfont from '@/components/icon.vue';
import TypeSelect from '@/components/meetingTypeSelect';
import api from '@/services/api';
export default {
  components: { DatePicker, Skeleton, TypeSelect, Iconfont },
  data() {
    return {
      date: new Date(),
      type: 0,
      loading: false,
      select: moment().date(),
    };
  },
  computed: {
    info() {
      return this.$store.state.auth.baseInfo;
    },
    id() {
      return this.$route.params.id;
    },
    userId() {
      return this.$store.state.auth.userInfo.personId;
    },
    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
    list() {
      return this.$store.state.meeting.meetingMyInMonth;
    },
    listFilter() {
      let res = [];
      this.list.filter((item, index) => {
        let judge = index + 1 === this.select;
        if (judge) res = item.list;
        return judge;
      });
      if (this.type === 1) {
        res = res.filter(item => item.creatorId !== this.userId);
      } else if (this.type === 2) {
        res = res.filter(item => item.creatorId === this.userId);
      }

      return res;
    },
    url() {
      return this.$route.path;
    },
    historyInfo() {
      return window.history.state && window.history.state.info;
    },
  },
  filters: {
    hourFilter(value) {
      return moment(value).format('HH:mm');
    },
  },
  methods: {
    async initData() {
      this.loading = !this.list.length;
      const [status, res] = await api.getMeetingRoomMyList({
        params: {
          month: moment(this.date).format('YYYY-MM'),
        },
      });
      if (!status) return;
      this.$store.commit('meeting/updateMeetingMyInMonth', res.data || []);
      this.$nextTick(() => {
        this.calculate(this.list);
      });

      this.loading = false;
    },
    dateFromat(value) {
      return [moment(value).day(), moment(value).date()];
    },
    hasMeeting(value) {
      return [value.some(item => item.creatorId !== this.userId), value.some(item => item.creatorId === this.userId)];
    },
    isCreator(value) {
      return value === this.userId;
    },
    calculate() {
      const width = document.body.clientWidth;
      this.$refs.topScroll.scrollLeft = (width / 750) * 80 * (this.select - 1);
    },
    hasAfter(index) {
      let now = this.listFilter[index];
      let next = this.listFilter[index + 1];
      if (index === this.listFilter.length - 1 && this.listFilter[index].status === 3) {
        return;
      }

      if (!next) return;
      if (now.endTime !== next.beginTime) {
        return 'space';
      }
    },
    editOrDelete(value) {
      console.log(
        value,
        moment()
          .add(15, 'minute')
          .valueOf()
      );
      if (value.creatorId !== this.userId) return [false, false];
      if (value.status === 3) {
        return [false, false];
      } else if (value.status === 2) {
        return [true, false];
      } else if (value.status === 0) {
        return moment()
          .add(15, 'minute')
          .valueOf() < value.beginTime
          ? [false, true]
          : [true, false];
      } else if (value.status === 1) {
        return [false, true];
      }
      return [false, false];
    },

    deleteMeeting(id, name) {
      Dialog.confirm({
        title: this.$t('common.warning'),
        message: this.$t('meeting.list.delete.tips') + name,
        beforeClose: async (action, done) => {
          if (action === 'confirm') {
            await api.deleteMeetingRoomInfo({
              id,
            });
            this.initData();
          }
          done();
        },
      });
    },
    goToMeeting(id) {
      this.$router.push({
        name: 'meetingInfo',
        params: { conferenceId: id },
      });
    },

    editMeeting(value) {
      this.$router.push({
        name: 'meetingEdit',
        params: { conferenceId: value.conferenceId },
      });
    },

    initState() {
      if (this.historyInfo) {
        this.date = this.historyInfo.date || new Date();
        this.select = this.historyInfo.select || moment().date();
      }
    },
  },

  watch: {
    date() {
      this.initData();
      window.history.replaceState(
        {
          info: {
            date: this.date,
            select: this.select,
          },
        },
        this.url
      );
    },
    select() {
      window.history.replaceState(
        {
          info: {
            date: this.date,
            select: this.select,
          },
        },
        this.url
      );
    },
  },
  created() {
    this.initState();
  },
  mounted() {
    this.initData();
    if (this.list.length > 0) {
      this.calculate(this.list);
    }
  },
};
</script>

<style lang="less" scoped>
.meeting {
  padding-bottom: 100px;

  .header {
    padding: 0 30px;
    height: 104px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;

    .right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 22px;
      color: #363d4d;
      letter-spacing: 0.4px;

      span {
        margin-right: 10px;

        &:nth-child(1)::before {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #ff9999;
          margin-right: 5px;
          margin-bottom: 3px;
        }

        &:nth-child(2)::before {
          content: '';
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #fad487;
          margin-right: 5px;
          margin-bottom: 3px;
        }
      }
    }
  }

  .top {
    height: 120px;
    background-color: white;
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;

    .con {
      display: flex;

      .date {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 0 8px;
        height: 120px;
        box-sizing: border-box;
        user-select: none;

        .area {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 72px;
          height: 90px;

          span {
            font-size: 24px;
            &:nth-child(1) {
              opacity: 0.8;
            }
            &:nth-child(2) {
              font-size: 28px;
              color: #3d424d;
              margin-top: 5px;
              font-weight: bold;
            }
          }

          &.active {
            background: #00ccbf;
            border-radius: 8px;
            border-radius: 8px;
            span {
              color: white;
            }
          }
        }

        .foot {
          height: 30px;
          width: 72px;
          display: flex;
          justify-content: center;
          align-items: center;
          .invite {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #ff9999;
            margin-right: 5px;
            margin-bottom: 3px;
          }

          .book {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: #fad487;
            margin-right: 5px;
            margin-bottom: 3px;
          }
        }
      }
    }
  }

  .main {
    margin-top: 30px;
    .list {
      display: flex;
      flex-direction: column;

      .listCon {
        display: flex;
        justify-content: center;
        align-items: flex-start;
      }

      .left {
        width: 132px;
        height: 150px;
        margin-right: 16px;
        padding-left: 16px;
        box-sizing: border-box;
        border-right: solid 5px #e6e6e6;
        font-size: 26px;
        color: #8a8e99;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;

        &::before {
          content: '';
          position: absolute;
          top: -10px;
          right: -12.5px;
          width: 20px;
          height: 20px;
          background: #f7f7f7;
          border: 4px solid #e6e6e6;
          border-radius: 50%;
          box-sizing: border-box;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          right: -12.5px;
          width: 20px;
          height: 20px;
          background: #f7f7f7;
          border: 4px solid #e6e6e6;
          border-radius: 50%;
          box-sizing: border-box;
        }

        .begin {
          position: absolute;
          top: 0;
          transform: translateY(-50%);
        }

        .end {
          position: absolute;
          bottom: 0;
          transform: translateY(50%);
        }
      }

      .rightCon {
        height: 150px;
        padding: 10px 0;
        box-sizing: border-box;
      }

      .right {
        width: 540px;
        background: white;
        border-radius: 10px;
        padding: 24px;
        box-sizing: border-box;
        margin-bottom: 21px;
        text-align: left;
        height: 130px;

        .top2 {
          text-align: left;
          font-size: 32px;
          color: #3d424d;
          display: flex;
          justify-content: space-between;

          .title {
            width: 350px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .invite {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #ff9999;
            margin-right: 12px;
            margin-bottom: 3px;
          }

          .book {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #fad487;
            margin-right: 12px;
            margin-bottom: 3px;
          }

          .status {
            font-size: 26px;
            color: #949aa4;
            font-weight: 500;

            &.num2 {
              color: #66c2ff;
            }

            &.num0 {
              color: #00ccbf;
            }
          }
        }

        .tips {
          font-size: 26px;
          color: #949aa4;
          margin-top: 10px;
          .personIcon {
            margin-right: 6px;
          }
        }
      }

      .addon {
        display: flex;
        justify-content: flex-end;
        padding-right: 30px;

        .option {
          border-left: 2px dashed #cccccc;
          width: 561px;
          box-sizing: border-box;
          user-select: none;

          .optionCon {
            margin: 16px 0 16px 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .bigDelete {
            width: 540px;
            background-color: white;
            height: 72px;
            border-radius: 10px;
            font-size: 28px;
            color: #ff9999;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              margin-left: 10px;
            }
          }

          .edit,
          .delete {
            width: 260px;
            background-color: white;
            height: 72px;
            border-radius: 10px;
            font-size: 28px;
            color: #ff9999;
            display: flex;
            justify-content: center;
            align-items: center;

            span {
              margin-left: 10px;
            }
          }

          .edit {
            color: #06ccbf;
          }
        }

        &.space {
          .option {
            min-height: 40px;
          }
        }
      }
    }
  }
}
</style>
